import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Grid,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import BugReportIcon from "@mui/icons-material/BugReport";
import AddIcon from "@mui/icons-material/Add";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import { useNavigate, useLocation } from "react-router-dom";
import BackgroundLetterAvatars from "./BackgroundLetterAvatars";
import useGlobalState from "../Context";

const SideNavbar = ({ anchor, toggleSideNavbar }) => {
  const [{ userDetails }] = useGlobalState();
  const userParam = userDetails?.userParam;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [activeURL, setActiveURL] = useState("/site-master");
  const personInfo = {
    name: userParam?.firstName + " " + userParam?.lastName,
    email: userParam?.email,
  };

  useEffect(() => {
    setActiveURL(pathname);
  }, [pathname]);

  const onClickRout = (rout) => {
    setActiveURL(rout);
    navigate(rout);
  };

  const drawerWidth = 240;
  return (
    <div>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            border: "none",
          },
        }}
        variant="permanent"
        anchor="left"
      >
        <Box className="sidePanel" role="presentation" sx={{
          overflow: "auto",
          scrollbarWidth: 'thin',
          '&::-webkit-scrollbar': {
            width: '0.3em',

          },
          '&::-webkit-scrollbar-track': {
            background: "#f1f1f1",
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#a3a6aabf',
            borderRadius: "5px",
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: 'rgb(206, 206, 206)',
            cursor: "pointer"

          }
        }}>
          <Box className="navCurve" sx={{ py: 3, px: 2 }}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <BackgroundLetterAvatars name={personInfo.name} />
              </Grid>
              <Grid item xs={12} textAlign="center" color={"#fff"}>
                <div>{personInfo.name}</div>
                <div className="profileSubTitle">{personInfo.email}</div>
              </Grid>
            </Grid>
          </Box>
          <Box
            onClick={() => toggleSideNavbar(false)}
            onKeyDown={() => toggleSideNavbar(false)}
            sx={{ flexGrow: 1 }}
          >
            <List sx={{ mt: 3 }}>
              <ListItem disablePadding>
                <ListItemButton
                  selected={
                    activeURL === "/appointment-details" ||
                      activeURL === "/edit-book-appointment" ||
                      activeURL === "/"
                      ? true
                      : false
                  }
                  className={
                    activeURL === "/appointment-details" ||
                      activeURL === "/edit-book-appointment" ||
                      activeURL === "/"
                      ? "active"
                      : "navItem"
                  }
                  onClick={() => onClickRout("/appointment-details")}
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}>
                    <ManageSearchIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    className="sideNavList"
                    primary="Appointments"
                  />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton
                  selected={
                    activeURL === "/raise-query" ||
                      activeURL === "/query-chat-thread"
                      ? true
                      : false
                  }
                  className={
                    activeURL === "/raise-query" ||
                      activeURL === "/query-chat-thread"
                      ? "active"
                      : "navItem"
                  }
                  onClick={() => onClickRout("/raise-query")}
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}>
                    <BugReportIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText className="sideNavList" primary="Raise Query" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton
                  selected={activeURL === "/add-fc" ? true : false}
                  className={activeURL === "/add-fc" ? "active" : "navItem"}
                  onClick={() => onClickRout("/add-fc")}
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}>
                    <ManageAccountsIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    className="sideNavList"
                    primary="Add / Remove FC"
                  />
                </ListItemButton>
              </ListItem>
              {/* <ListItem disablePadding>
                <ListItemButton
                  selected={
                    activeURL === "/bulk-appointment" ||
                      activeURL === "/bulk-appointment-list"
                      ? true
                      : false
                  }
                  className={
                    activeURL === "/bulk-appointment" ||
                      activeURL === "/bulk-appointment-list"
                      ? "active"
                      : "navItem"
                  }
                  onClick={() => onClickRout("/bulk-appointment")}
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}>
                    <UploadFileIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    className="sideNavList"
                    primary="Bulk Appointment"
                  />
                </ListItemButton>
              </ListItem> */}
            </List>
          </Box>
          <Box>
            <Divider />
            <Box sx={{ p: 2 }}>
              <Button
                startIcon={<AddIcon />}
                sx={{ color: "white" }}
                variant="contained"
                onClick={() => onClickRout("/book-appointment")}
              >
                Book Appointment
              </Button>
            </Box>
          </Box>
        </Box>
      </Drawer>
    </div>
  );
};
export default SideNavbar;
